module.exports = __webpack_public_path__ + "static/img/Nice-Stadium.e2c982f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nice-Stadium.jpg
// module id = nors
// module chunks = 0